import React from "react";
import { useLanguage } from "../../../contexts/LanguageContext";
import { ArrowRight, ArrowLeft } from "lucide-react";
import "./SectionHeader.css";

export default function SectionHeader({
  title,
  subtitle    = null,
  actionButton= null,
  align       = "left",
  variant     = "default",
  icon        = null,   // ← NEW: Lucide icon component
}) {
  const { lang } = useLanguage();
  const isAr = lang === "ar";
  const ArrowIcon = isAr ? ArrowLeft : ArrowRight;

  return (
    <div
      className={`section-header-wrapper align-${align} variant-${variant}`}
      dir={isAr ? "rtl" : "ltr"}
    >
      <div className="section-header-content">
        <div className="section-header-main">
          <div className="section-header-title-group">
            {icon && (
              <span className="section-header-icon">
                {icon}
              </span>
            )}
            <h3 className="section-header-title">{title}</h3>
          </div>

          {actionButton && (
            <button
              className="section-header-action"
              onClick={actionButton.onClick}
            >
              <span>{actionButton.text}</span>
              {actionButton.icon && (
                <span className="action-icon">
                  <ArrowIcon size={15} />
                </span>
              )}
            </button>
          )}
        </div>

        {subtitle && (
          <p className="section-header-subtitle">{subtitle}</p>
        )}
      </div>

      <div className="section-header-line">
        <div className="line-accent" />
      </div>
    </div>
  );
}